// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.strip-of-pills_f24357af {
  display: inline;
  margin-right: 2rem;
}
.strip-of-pills__label_f24357af {
  display: inline-block;
  font-weight: 600;
  vertical-align: middle;
  margin: 0 0.667rem 0.667rem 0;
}
.inline-button_f24357af.inline-button_f24357af {
  margin: 0 0.667rem 0.667rem 1.334rem;
  vertical-align: middle;
  display: inline-block;
}
.strip-of-pills-group_f24357af {
  max-height: 160px;
  margin-top: -0.25rem;
}
.strip-of-pills-group_f24357af .strip-of-pills_f24357af {
  margin-right: 1.334rem;
}
.strip-of-pills-group_f24357af .strip-of-pills_f24357af .inline-button_f24357af {
  margin-right: 0;
}
.strip-of-pills-group__caption_f24357af {
  margin: 0 1.334rem 0.667rem 0;
  display: inline-block;
  vertical-align: middle;
  font-weight: 600;
}
.strip-of-pills-group__overflow_f24357af {
  padding-top: 0.25rem;
}
.strip-of-pills-group__overflow_expanded_f24357af {
  display: inline;
}
.strip-of-pills-group__overflow_collapsed_f24357af {
  white-space: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
}
.strip-of-pills-group__overflow_collapsed_f24357af::-webkit-scrollbar {
  display: none;
}
.strip-of-pills-group__buttons_f24357af {
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  padding-top: 0.25rem;
}
.strip-of-pills-group__buttons_f24357af .inline-button_f24357af {
  margin: 0 0 0.667rem 0;
}
.strip-of-pills-group__buttons_f24357af.strip-of-pills-group__buttons__overflow_f24357af {
  padding-left: 1.334rem;
}
.strip-of-pills-group__buttons_f24357af.strip-of-pills-group__buttons__overflow_f24357af::after {
  content: '';
  position: absolute;
  right: 100%;
  top: 0;
  height: 100%;
  width: 4.584rem;
  background: linear-gradient(to right, rgba(255,255,255,0) 0%, #fff 70%, #fff 100%);
  opacity: 0.8;
}
.strip-divider_f24357af {
  margin: 0 1.334rem 0.667rem 1.334rem;
  border-left: 1px solid #84919b;
  height: 1.5rem;
  display: inline-block;
  vertical-align: middle;
}
.strip-divider_f24357af:first-child {
  margin-left: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"strip-of-pills": `strip-of-pills_f24357af`,
	"strip-of-pills__label": `strip-of-pills__label_f24357af`,
	"inline-button": `inline-button_f24357af`,
	"strip-of-pills-group": `strip-of-pills-group_f24357af`,
	"strip-of-pills-group__caption": `strip-of-pills-group__caption_f24357af`,
	"strip-of-pills-group__overflow": `strip-of-pills-group__overflow_f24357af`,
	"strip-of-pills-group__overflow_expanded": `strip-of-pills-group__overflow_expanded_f24357af`,
	"strip-of-pills-group__overflow_collapsed": `strip-of-pills-group__overflow_collapsed_f24357af`,
	"strip-of-pills-group__buttons": `strip-of-pills-group__buttons_f24357af`,
	"strip-of-pills-group__buttons__overflow": `strip-of-pills-group__buttons__overflow_f24357af`,
	"strip-divider": `strip-divider_f24357af`
};
export default ___CSS_LOADER_EXPORT___;
